define('button-disabler',[],function() {
	var exports = {
		disableUntilDone: function (button, promise) {
			exports.disable(button);
			promise
				.catch(function() {})
				.then(function() {
					exports.enable(button);
				});
		},

		disable: function (button) {
			button.prop('disabled', true);
			button.addClass('waiting');
		},

		enable: function (button) {
			button.prop('disabled', false);
			button.removeClass('waiting');
		}
	};

	return exports;
});

